import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { FormName } from 'redux-form';
const HocFormName = (ChildComponent) => (props) => (_jsx(FormName, { children: (data) => _jsx(ChildComponent, Object.assign({}, props, data)) }));
export default HocFormName;
